import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListEmployers = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_EMPLOYERS'})
}

export const unmountDetailEmployers = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_EMPLOYERS'})
}

export const unmountMasterEmployers = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_EMPLOYERS'})
}

export const listEmployers = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_EMPLOYERS' })
  return API.GET('/employers/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_EMPLOYERS_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_EMPLOYERS_FAILED' }), 
    ))
  })
}

export const detailEmployer = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_EMPLOYERS' })
  const params = {
    'id': id
  }
  API.GET('/employers/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_EMPLOYERS_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_EMPLOYERS_FAILED' }), 
      ))
    )
  })
}

export const masterEmployers = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_EMPLOYERS' })
  return API.GET('/employers_type/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_EMPLOYERS_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_EMPLOYERS_FAILED' }), 
    ))
  })
}

export const createEmployer = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/employers/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editEmployer = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/employers/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableEmployer = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/employers/enableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableEmployer = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/employers/disableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}